import { httpsCallable } from "firebase/functions";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

// Google types are declared in types/google.d.ts
/// <reference path="../types/google.d.ts" />

interface GoogleOAuthResponse {
  code?: string;
  error?: string;
}

export function useGoogleCalendarConnect() {
  return (userId?: string) => {
    if (!window.google?.accounts?.oauth2) {
      console.error("Google Identity Services not available");
      return;
    }

    // TIJDELIJKE HARDCODE - vervang met jouw echte Google Client ID
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "1003348135208-35tmpma778jvlliliplq1v7gtrpurml7.apps.googleusercontent.com";
    
    console.log('🔍 Debug - Client ID from env:', process.env.REACT_APP_GOOGLE_CLIENT_ID);
    console.log('🔍 Debug - Using Client ID:', clientId);
    console.log('🔍 Debug - All REACT_APP env vars:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP')));
    console.log('🔍 Debug - Google services available:', !!window.google?.accounts?.oauth2);
    
    if (clientId === "PLAATS_HIER_JOUW_GOOGLE_CLIENT_ID.apps.googleusercontent.com") {
      console.error("❌ Please replace the hardcoded Client ID with your real Google Client ID");
      alert("Please edit src/hooks/useGoogleCalendarConnect.ts and replace the hardcoded Client ID!");
      return;
    }

    // @ts-ignore - Google types not available
    const client = window.google.accounts.oauth2.initCodeClient({
      client_id: clientId,
      scope: [
        "openid",
        "email", 
        "profile",
        "https://www.googleapis.com/auth/calendar.events",
      ].join(" "),
      ux_mode: "popup",
      callback: async (resp: GoogleOAuthResponse) => {
        if (!resp?.code) {
          console.error("GIS no code received", resp);
          return;
        }

        try {
          console.log("🔑 Google auth code received, calling linkGoogleAccount...");
          
          const functions = getFunctions(undefined, 'europe-west1'); // Match deployed region
          const linkGoogleAccount = httpsCallable(functions, "linkGoogleAccount");
          const result = await linkGoogleAccount({ code: resp.code });
          
          console.log("✅ Google Calendar linked successfully:", result.data);

          // Update local Firestore if userId provided
          if (userId) {
            await updateDoc(doc(db, 'users', userId), {
              'integrations.googleCalendar': true,
              'integrations.googleCalendarConnectedAt': new Date()
            });
            console.log("📅 Local user profile updated");
          }

          // Trigger success in UI (custom event)
          window.dispatchEvent(new CustomEvent('googleCalendarSuccess'));

        } catch (error: any) {
          console.error("❌ Error linking Google Calendar:", error);
          
          // Trigger error in UI (custom event)
          window.dispatchEvent(new CustomEvent('googleCalendarError', { 
            detail: error.message || 'Failed to connect Google Calendar' 
          }));
          
          // Handle specific error types
          if (error.message?.includes('redirect_uri_mismatch')) {
            console.error("Configuration error: Redirect URI mismatch in Google Console");
          } else if (error.message?.includes('not configured')) {
            console.error("Server error: Google OAuth credentials not configured");
          }
        }
      },
    });

    client.requestCode();
  };
}
